import React from 'react';
import GlobalFilters from '../GlobalFilters/GlobalFilters';

const FilterSidebar = ({
  setOpenFilter,
  openFilter,
  initialValues,
  isSearching,
  setFilters,
  filters,
}) => {
  return (
    <>
      <div className={`${openFilter ? 'backdrop' : ''}`}></div>
      <div
        className={`filter_sec p-3 d-flex flex-column ${
          openFilter ? 'active' : ''
        }`}
      >
        <div className="head_sec w-100">
          <h4>Filter</h4>
        </div>

        <div className="w-100 mid_sec h-100">
          <GlobalFilters
            initialValues={initialValues}
            isSearching={isSearching}
            setFilters={setFilters}
            filters={filters}
            setOpenFilter={setOpenFilter}
            openFilter={openFilter}
          />
        </div>

        <div className="btn_sec d-flex justify-content-end">
          <button
            className="btn btn-secondary font-600"
            type="button"
            style={{ width: '140px', height: '34px' }}
            onClick={() => setOpenFilter(!openFilter)}
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default FilterSidebar;
